/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        this.affix();
        this.carousels();
        this.photoswipe(); 
        this.contactForm();
        this.newsletterForm();
        //this.proximityHover();
        this.socialPopup();
        this.loadProjects();
        //this.imagesDuotone();

        this.footerCollapse();

        // Remove yellow placeholder focus from inputs
        if(navigator.userAgent.toLowerCase().indexOf("chrome") >= 0 || navigator.userAgent.toLowerCase().indexOf("safari") >= 0){
          window.setInterval(function(){
            $('input:-webkit-autofill').each(function(){
              var clone = $(this).clone(true, true);
              $(this).after(clone).remove();
            });
          }, 20);
        }

        $(document).on('click', 'a[href*=\\#]' , function(event){
          var id = $(this).attr('href');
          if ( $(id).length > 0 && $(this).hasClass('btn-inline-scroll') ) {
            event.preventDefault();
            $('html,body').animate({ scrollTop:$(this.hash).offset().top - 250 }, 500);
          }
        });

        $(document).on('click','.site-nav-overlay',function(){
          $('.contrast-navbar-toggler').click();
        });

        $(document).on('click','.section.photo-gallery .btn-text.btn-text--gallery',function(e){
          e.preventDefault();
          $(this).closest('.photo-gallery').find('.gallery_thumb[data-index="1"]').click();
        });
        $(document).on('click','.contrast-navbar-toggler', function(e){
          e.preventDefault();
          if ( $('body').hasClass('menu-open') ) {
            Sage.common.navAnimateOut();
          } else {
            $('body').addClass('menu-open');
            $('.contrast-navbar-toggler').addClass('menu-open');
            Sage.common.navAnimateIn();
          }
          
        });

        $(document).on('click','.section-pd',function(e){
          e.preventDefault();
          var $target = $(this).closest('section').next();
          if ( $target.length > 0 ) {
            $('html, body').animate({ scrollTop: $target.offset().top }, 800, 'swing', function() {} );
          }
        });
        var velocity = 0.130;

        function update_header_bg(){ 
          var pos = $(window).scrollTop(); 
          $('.page-header .background-section').each(function() { 
              var $element = $(this);
          // subtract some from the height b/c of the padding
          var height = $element.height()-18;
            $(this).css('backgroundPosition', 100 - Math.round((height - pos) * velocity) +  '%'); 
          }); 
        };

        $(window).bind('scroll', update_header_bg);  

        $( window ).scroll(function() {

          var value = ($(window).scrollTop()/500);
          var value_font = 1-($(window).scrollTop()/1200);
          if (value < 0) {
            value = 0;
          }
          if (value_font < 0) {
            value_font = 0;
          }
          $('.page-header .section-pattern').css({
             'bottom': ' -'+ ( 100 + value*120 ) +'px'
          });
          $('.page-header .container').css({
             'transform': ' translateY('+value_font+'%) matrix('+value_font+', 0, 0, '+value_font+', 0, 0)'
          });
        });

        $(document).on('click','.ci-contact-buttons-holder a.cb-info',function(e){
          e.preventDefault();
          $(this).closest('ul').find('a:not(.cb-info)').toggleClass('info-open');
        });

        $(document).on('click','.our-process .section-title h2 > a',function(e){
          e.preventDefault();
          var target = $(this).attr('href');
          $(target).closest('.process-section').find('.process-presentation.active').fadeOut(500,function(){
            $(this).removeClass('active');
            $(target).addClass('active').fadeIn(500);
          });
          
          $(this).closest('h2').find('.active').removeClass('active');
          $(this).addClass('active');
        });

        $('.service-box .title-container span').matchHeight();
        $('.our-process .processbox-matchheight-dp').matchHeight({byRow: false});
        $('.our-process .processbox-matchheight-bp').matchHeight({byRow: false});

        $('.styled-form').each(function(){
          $(this).find('input, textarea').focus(function(){
            $(this).parents('.form-group').addClass('focused');
          });
          $(this).find('input, textarea').blur(function(){
            var inputValue = $(this).val();
            if ( inputValue === "" ) {
              $(this).removeClass('filled');
              $(this).parents('.form-group').removeClass('focused');  
            } else {
              $(this).addClass('filled');
            }
          });
        });

      },
      navAnimateOut: function() {
        anime.timeline()
          .add({
            targets: '.site-nav .site-primary-nav > ul > li',
            translateY: [0, -150],
            translateX: [0, -50],
            opacity: [1,0],
            easing: "easeInBack",
            duration: 800,
            delay: function(el, i) {
              return 300 + 30 * i;
            }
          });
        anime.timeline()
          .add({
            targets: '.site-nav .contact-details',
            translateY: [0, -150],
            translateX: [0, 50],
            opacity: [1,0],
            easing: "easeInBack",
            duration: 800,
            delay: function(el, i) {
              return 300 + 30 * i;
            }
          });
        anime.timeline()
          .add({
            targets: '.site-nav .btn-text',
            translateY: [0, -150],
            translateX: [0, 50],
            opacity: [1,0],
            easing: "easeInBack",
            duration: 800,
            delay: function(el, i) {
              return 300 + 30 * i;
            }
          });
        anime.timeline()
          .add({
            targets: '.site-nav .contact-details > li',
            translateY: [0, -150],
            translateX: [0, 50],
            opacity: [1,0],
            easing: "easeInBack",
            duration: 800,
            delay: function(el, i) {
              return 300 + 30 * i;
            }
          });
        anime.timeline()
          .add({
            targets: '.site-nav .logo-container',
            translateY: [0, -150],
            opacity: [1,0],          
            easing: "easeInBack",
            duration: 800,
            complete: function() {
              $('body').removeClass('menu-open');
              $('.contrast-navbar-toggler').removeClass('menu-open');
              $('body').removeClass('animating');
            },  
            delay: function(el, i) {
              return 300 + 30 * i;
            }
          });
        
      },
      navAnimateIn: function() {
        anime.timeline()          
          .add({
            targets: '.site-nav .site-primary-nav > ul > li',
            translateY: [-150, 0],
            translateX: [-50, 0],
            opacity: [0,1],           
            easing: "easeOutCubic",
            duration: 800,
            delay: function(el, i) {
              return 300 + 30 * i;
            }
          });
        anime.timeline()          
          .add({
            targets: '.site-nav .contact-details > li',
            translateY: [-150, 0],
            translateX: [50, 0],
            opacity: [0,1],  
            easing: "easeOutCubic",
            duration: 800,
            delay: function(el, i) {
              return 300 + 30 * i;
            }
          });
        anime.timeline()          
          .add({
            targets: '.site-nav .contact-details',
            translateY: [-150, 0],
            translateX: [50, 0],
            opacity: [0,1],  
            easing: "easeOutCubic",
            duration: 800,
            delay: function(el, i) {
              return 300 + 30 * i;
            }
          });
        anime.timeline()          
          .add({
            targets: '.site-nav .btn-text',
            translateY: [-150, 0],
            translateX: [50, 0],
            opacity: [0,1],  
            easing: "easeOutCubic",
            duration: 800,
            delay: function(el, i) {
              return 300 + 30 * i;
            }
          });
        anime.timeline()
          .add({
            targets: '.site-nav .logo-container',
            translateY: [-150, 0],
            opacity: [0,1],
            easing: "easeOutCubic",
            duration: 1200,
            delay: function(el, i) {
              return 300 + 30 * i;
            }
          });        
      },
      affix: function() {
        var offset = 150;
        if(window.innerWidth <= 767) {
           offset = 50 ;
        }
        $("#main-site-header").headroom({
          "offset": offset,
          "tolerance": 5,
          "classes": {
            "initial": "animated",
            "pinned": "slideDown",
            "unpinned": "slideUp"
          }
        });
      },
      carousels: function() {
        $('.testimonials-slider .testimonial-slider-cnt').owlCarousel({
          center: true,
          items: 1,
          loop: true,
          nav: false,
          dots: true,
          margin: 30,
          autoHeight: false,
          drag: true,
          autoplay: true,
        });

        $('.sidebar-testimonial .owl-carousel').owlCarousel({
          center: true,
          items: 1,
          loop: true,
          nav: false,
          dots: true,
          margin: 30,
          autoHeight: false,
          drag: true,
          autoplay: true,
        });

        $('.service-work-slider .owl-carousel').owlCarousel({
          center: false,
          items: 3,
          loop: false,
          nav: true,
          dots: false,
          margin: 10,
          drag: true,          
          responsive:{
            0:{
              items:1,
              center: true,
              loop: true,
              dots: true,
              nav: false,
              stagePadding: 80,
            },
            768:{
              items:3,
              center: false,
              loop: true,
              dots: true,
              nav: false,
            },
            991:{
              items:2,
            },
            1200:{
              items:3,
            }
          }
        });

        $('section.our-process.our-process--mobile .owl-carousel').owlCarousel({
          center: true,
          items: 1,
          loop: true,
          nav: false,
          dots: true,
          margin: 30,
          autoHeight: true,
          drag: true,
          autoplay: false
        });

        if(window.innerWidth <= 767) {
          $('.services-tabs .owl-carousel').owlCarousel({
            center: true,
            items: 1,
            loop: true,
            nav: false,
            dots: true,
            margin: 30,
            autoHeight: true,
            drag: true,
            autoplay: true
          });
        } 

      

      },
      photoswipe: function() {
        var photoswipe_items = [];

        $('.photoswipe-gallery').each( function() {
          var gallery_id = $(this).attr('data-galleryid');
          var $gallery_main_parent = $(this);
          var $pic      = $(this),
          total_img = $pic.find('a.gallery_thumb').length,
          getItems = function() {
            var photoswipe_items_current = [];
            var next = '';
            var current = '';
            var prev = '';
            $pic.find('a.gallery_thumb').each(function() {
              var $href   = $(this).attr('href'),
                  $size   = $(this).data('size').split('x'),
                  $width  = $size[0],
                  $height = $size[1],
                $title  = $(this).attr('data-title');
              var thumbnails = '';
              if ( $title  ) {
                thumbnails = '<p class="gallery_caption">' + $title + '</p><ul>';
              } else {
                thumbnails = '<ul>';
              }
              var parent = $(this);
              if ( parseInt( $(this).attr('data-index') ) === 1 ) {
                prev = $gallery_main_parent.find('.gallery_thumb[data-index="'+total_img+'"]');
                current = $(this);
                next = $gallery_main_parent.find('.gallery_thumb[data-index="'+ ( parseInt( $(this).attr('data-index') ) + 1 )+'"]');
              }
              if ( parseInt( $(this).attr('data-index') ) === ( total_img + 1 ) ) {
                next = $gallery_main_parent.find('.gallery_thumb[data-index="1"]');
                current = $(this);
                prev = $gallery_main_parent.find('.gallery_thumb[data-index="'+(  parseInt( $(this).attr('data-index') ) - 1 )+'"]');;
              }

              if ( ( parseInt( $(this).attr('data-index') ) !== 1 ) && ( parseInt( $(this).attr('data-index') ) !== total_img )  ) {
                next = $gallery_main_parent.find('.gallery_thumb[data-index="'+( parseInt( $(this).attr('data-index') ) + 1 )+'"]');
                prev = $gallery_main_parent.find('.gallery_thumb[data-index="'+( parseInt( $(this).attr('data-index') ) - 1 )+'"]');
                current = $(this);
              }

              thumbnails += '<li data-index="'+prev.attr('data-index')+'"><span style="background-image: url('+prev.attr('href')+');"></span></li>';
              thumbnails += '<li data-index="'+current.attr('data-index')+'" class="active"><span style="background-image: url('+current.attr('href')+');"></span></li>';
              thumbnails += '<li data-index="'+next.attr('data-index')+'"><span style="background-image: url('+next.attr('href')+');"></span></li>';

              thumbnails += '</ul>';
              var item = {
                  src: $href,
                  w:$width,
                  h:$height,
                  title: thumbnails
              };
              photoswipe_items_current.push(item) ;
            });
            return photoswipe_items_current;
          };
          photoswipe_items[gallery_id] = getItems();
        });
        var $pswp = $('.pswp')[0];
        $('.site-nav').mCustomScrollbar({
          axis:"y",
          theme:"minimal-dark"
        });

        $(document).on('lity:open', function(event, instance) {
          $('body').addClass('lity-open');
        });

        $(document).on('lity:close', function(event, instance) {
          $('body').removeClass('lity-open');
        });

        var lightBox;
        $(document).on('click','a.gallery_thumb',function(event){
          event.preventDefault();
          var $pswp = $('.pswp')[0];
          var $index = parseInt( $(this).attr('data-index') ) - 1;
          var $large_image_container = $(this).closest('.photoswipe-gallery');
          var $elem = $(this);
          var gallery_id = $large_image_container.attr('data-galleryid');
          var options = {
              index: $index,
              bgOpacity: 0.7,
              zoomEl: true,
              shareEl: true,
              counterEl: true,
              arrowEl: true,
              preloaderEl: true,
              showHideOpacity: true,
              maxSpreadZoom: 2,
              getThumbBoundsFn: function(index) {
                // get window scroll Y
                var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                // optionally get horizontal scroll
                // get position of element relative to viewport
                var rect = $elem[0].getBoundingClientRect();
                // w = width
                return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                // Good guide on how to get element coordinates:
                // http://javascript.info/tutorial/coordinates
              }

          };
          // Initialize PhotoSwipe
          lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, photoswipe_items[gallery_id], options);
          lightBox.init();
        });

        $(document).on('click','.pswp__caption ul li',function(e){
          var $pswp = $('.pswp')[0];
          var $index = parseInt( $(this).attr('data-index') );

          lightBox.goTo(parseInt( $index ) - 1 );
        });
      },
      contactForm: function() {
        function isValidEmailAddress(emailAddress) {
          var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
          return pattern.test(emailAddress);
        }
        $.validator.addMethod("supervalidemail", function(value, element) {
        // allow any non-whitespace characters as the host part
            return isValidEmailAddress( value );
        }, 'Please enter a valid email address.');

        $.validator.addMethod("noSpace", function(value, element) {
          return value === '' || value.trim().length !== 0;
        }, "No space please and don't leave it empty");

        $.validator.addMethod("validphone", function(value, element) {
          var phoneNumberPattern = new RegExp(/^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|(\([0-9]{1,5}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/);
          return phoneNumberPattern.test(value);
        }, 'Please specify a valid phone number' );

        var ContactFormValidation = function() {
          var instance = this;
          instance.settings = {
            errorElement: 'span',
            errorPlacement: function(error, element) {
                error.appendTo(element.closest('.form-group'));
            },
            submitHandler: function( form ) {
              $theform = $(form);
              $theform.find('button[type="submit"]').button('loading');

              var form_data = $theform.serialize();
              console.log(form_data);
              $.post(
                ci_frontend.ajaxurl,
                {
                  action: "ci_contact_form",
                  formdata: form_data,
                },
                function(msg)
                {
                  obj = JSON.parse( msg );
                  // console.log(obj);
                  if ( obj.success ) {
                    $theform.parent().find('.form-error-message').slideUp();
                    $theform.slideUp(function(){
                      $theform.parent().find('.thank-you-page-content').slideDown();
                    });
                    $('html, body').animate({ scrollTop:  $theform.parent().find('.thank-you-page-content').offset().top - 200 }, 800, 'swing', function() {} );
                  } else {
                    $theform.parent().find('.form-error-message').slideDown();
                    $theform.parent().find('.thank-you-page-content').slideUp();
                  }
                  $theform.find('button[type="submit"]').button('reset');
                }
              );
              return false;
            },
            afterSubmit: function( form ) {
                $(form).find('button[type="submit"]').button('reset');
            },
            highlight: function(element, errorClass, validClass) {
                $(element).closest('.form-group').addClass(errorClass).removeClass(validClass);
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).closest('.form-group').removeClass(errorClass).addClass(validClass);
            },
            focusInvalid: false,
            invalidHandler: function(form, validator) {
              if (!validator.numberOfInvalids())
                return;

              $('html, body').animate({
                scrollTop: $(validator.errorList[0].element).offset().top - $('header.main-header').height() - 60
              }, 'fast');

            },
            rules: {
                "c_name": {
                  required: true,
                  noSpace: true
                },                
                "c_phone": {
                  required: true,
                  noSpace: true
                },
                "c_terms": {
                  required: true,
                },
                "c_email": {
                  required: true,
                  email: true,
                  noSpace: true,
                  supervalidemail: true
                },
                "c_hpf": {
                  minlength: 0,
                  maxlength: 0,
                },
                "c_message": {
                  required: true,
                  noSpace: true
                },
            },
            messages: {
              "c_name": {
                required: 'This field is required.',
                noSpace: 'This field is required.'
              },
              "c_phone": {
                required: 'This field is required.',
                noSpace: 'This field is required.'
              },
              "c_terms": {
                required: 'This field is required.',
              },
              "c_email": {
                required: 'This field is required.',
                email: 'Please enter a valid email address.',
                supervalidemail: 'Please enter a valid email address.',
                noSpace: 'This field is required.'
              },
              "c_message": {
                required: 'This field is required.',
                noSpace: 'This field is required.'
              },
              "c_hpf": {
                minlength: 'This field is required.',
                maxlength: 'This field is required.'
              }
            }

          }
          instance.init = function() {
            var contact_form = $(".get-in-touch-form");
            // CONSULTATION FORM
            if ( contact_form.length == 1 ) {
              contact_form.each(function(){
                $(this).validate(instance.settings);
              });
            }
          }
          instance.init();
        }
        var contact_form   = new ContactFormValidation();

      },
      socialPopup: function() {
        // Create browser compatible event handler.
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
        // Listen for a message from the iframe.
        eventer(messageEvent, function(e) {
          if (isNaN(e.data)) { return; }

          // replace #sizetracker with what ever what ever iframe id you need
          jQuery('iframe')[0].style.height = e.data + 'px';
          Sage.common.matchHeights();
        }, false);

        function popupwindow(uri, name, w, h) {
          var y = window.top.outerHeight / 2 + window.top.screenY - ( h / 2);
          var x = window.top.outerWidth / 2 + window.top.screenX - ( w / 2);

          var win = window.open(uri, name, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+y+', left='+x );
          var interval = window.setInterval(function() {
              try {
                  if (win == null || win.closed) {
                    window.clearInterval(interval);
                  }
              }
              catch (e) {
              }
          }, 1000);
          return win;
        }

        $(document).on('click','.photo-gallery .share-box a', function(e){
          if ( ! $(this).closest('li').hasClass('mail-icon') ) {
            e.preventDefault();
            var width = 600;
            var height = 500;
            popupwindow( $(this).attr('href'), $(this).attr('title'), width, height );
          }
        });

      },
      imagesDuotone: function() {
        /**
         * Convert hex to RGB value
         *
         * return [array] (r,g,b)
         */
        function hexToRgb(hex) {
            var bigint = parseInt(hex, 16),
                r = (bigint >> 16) & 255,
                g = (bigint >> 8) & 255,
                b = bigint & 255;
            return [r,g,b];
        }

        /**
         * Create Duotone Matrix Values
         *
         * return [string] (matrix values)
         */
        function duotone (hexes) {
            // After many failed attempts at the Matrix voodoo I found the right path here:
            // https://ines.io/blog/dynamic-duotone-svg-jade
            var hex = hexes.split(',');
            var matrix = document.querySelector('.color-matrix');
            var color1 = hexToRgb(hex[0]);
            var color2 = hexToRgb(hex[1]);
            
            var c1   = {};
            c1.red   = color1[0] / 256;
            c1.green = color1[1] / 256;
            c1.blue  = color1[2] / 256;
            
            var c2   = {};
            c2.red   = color2[0] / 256;
            c2.green = color2[1] / 256;
            c2.blue  = color2[2] / 256;
            
            var value = [];
            value = value.concat([c1.red - c2.red, 0, 0, 0, c2.red]);
            value = value.concat([c1.green - c2.green, 0, 0, 0, c2.green]);
            value = value.concat([c1.blue - c2.blue, 0, 0, 0, c2.blue]);
            value = value.concat([0, 0, 0, 1, 0]);

            return value.join(' ');
        }


        /**
         * Create Additional Color Filters
         *
         * return [bool]
         */
        function createSvgFilters (hex,i) {

            var filterNum = 'duotone_' + i,
                ns = 'http://www.w3.org/2000/svg',
                svg = document.createElementNS(ns,'svg'),
                filterEl = document.createElementNS(ns,"filter"),
                matrix = document.createElementNS(ns,"feColorMatrix");
            
                svg.setAttribute('style','color-interpolation-filters: sRGB');
                svg.classList.add('svg-filter');
                filterEl.setAttribute('id','duotone_' + i);
                matrix.setAttribute('type', 'matrix');
                matrix.setAttribute('values', duotone(hex));
            
            document.body.appendChild(svg).appendChild(filterEl).appendChild(matrix);
            return;

        }

        /**
         * Fire it up!
         * 
         * Runs through the DOM and looks for data-hex
         * attributes. Takes the values and applies a 
         * gradient map.
         */

        (function(){
           var gradientImages = document.querySelectorAll('[data-hex]');
            gradientImages.forEach(function(img, i) {
                hex = img.dataset.hex;
                createSvgFilters(hex,i);
                filterName = '#duotone_' + i;

                $(img).css('filter','url('+ filterName +')');
            }); 
        })();

      },
      newsletterForm: function() {
        function isValidEmailAddress(emailAddress) {
          var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
          return pattern.test(emailAddress);
        }
        $.validator.addMethod("supervalidemail", function(value, element) {
        // allow any non-whitespace characters as the host part
            return isValidEmailAddress( value );
        }, 'Please enter a valid email address.');

        $.validator.addMethod("noSpace", function(value, element) {
          return value === '' || value.trim().length !== 0;
        }, "No space please and don't leave it empty");

        $.validator.addMethod("validphone", function(value, element) {
          var phoneNumberPattern = new RegExp(/^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|(\([0-9]{1,5}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/);
          return phoneNumberPattern.test(value);
        }, 'Please specify a valid phone number' );

        var NewsletterFormValidation = function() {
          var instance = this;
          instance.settings = {
            errorElement: 'span',
            errorPlacement: function(error, element) {
              error.appendTo(element.closest('.form-group'));
            },
            highlight: function(element, errorClass, validClass) {
              $(element).closest('.form-group').addClass(errorClass).removeClass(validClass);
            },
            unhighlight: function(element, errorClass, validClass) {
              $(element).closest('.form-group').removeClass(errorClass).addClass(validClass);
            },
            focusInvalid: false,
            invalidHandler: function(form, validator) {
              if (!validator.numberOfInvalids()) {
                return;
              }
              $(validator.errorList[0].element).focus();
            },
            submitHandler: function( form ) {
              $theform = $(form);
              $theform.find('button[type="submit"]').button('loading');

              var form_data = $theform.serialize();
              $.post(
                ci_frontend.ajaxurl,
                {
                  action: "ci_newsletter_subscribe",
                  formdata: form_data,
                },
                function(msg)
                {
                  obj = JSON.parse( msg );
                  if ( obj.success == true ) {
                    $theform.parent().find('.form-error-title').hide();
                    $theform.slideUp(function(){
                      $theform.parent().find('.mc_thank_you_message').slideDown();
                    });
                  } else {
                    $theform.parent().find('.form-error-title').show();
                    var $error_alert = $theform.parent().find('.form-error-title');
                    $error_alert.empty().append('<p class="errors">'+obj.message+'</p>');
                  }
                  $theform.find('button[type="submit"]').button('reset');
                }
              );
              return false;
            },
            rules: {
              "newsletter_name": {
                required: true,
                noSpace: true
              },              
              "newsletter_email": {
                required: true,
                email: true,
                noSpace: true,
                supervalidemail: true
              },
              "newsletter_tc": {
                required: true,
                noSpace: true
              }
            },
            messages: {
              "newsletter_name": {
                "required": "This field is required.",
                "noSpace": "This field is required."
              },             
              "newsletter_email": {
                "required": "This field is required.",
                "email": "Invalid e-mail address.",
                "supervalidemail": "Invalid e-mail address.",
                "noSpace": "This field is required."
              },
               "newsletter_tc": {
                "required": "This field is required.",
                "noSpace": "This field is required."
              },
            }
          }
          instance.init = function() {
            var newsletterForm = $("#ci_newsletter_form");
            if (newsletterForm.length == 1) {
              newsletterForm.find('button[type="submit"]').button('reset');
              newsletterForm.validate(instance.settings);
            }
          }
          instance.init();
        }
        var nwsltr = new NewsletterFormValidation;
      },
      loadProjects: function() {
        // Main Archive
        $(document).on('click','.our-work-listing-grid .sector-filters li a',function(e){
          e.preventDefault();
          var url = $(this).attr('href');
          $('.breadcrumb_last').text($(this).text());
          $('#contrast-load-more-container').load(url + ' .work-grid-listing, .sector-filters', function(){
            
            $('.our-work-listing-grid .sector-filters').empty().html($('#contrast-load-more-container').find('.sector-filters').html());
            anime.timeline()
              .add({
                targets: '.our-work-listing-grid .work-grid-listing .project-item--parent:nth-child(odd)',
                translateY: [0, -10],
                translateX: [, -200],
                opacity: [1,0],
                easing: "easeOutCubic",
                duration: 600,
                delay: function(el, i) {
                  return 200 + 30 * i;
                }
              });
            anime.timeline()
              .add({
                targets: '.our-work-listing-grid .work-grid-listing .project-item--parent:nth-child(even)',
                translateY: [0, -10],
                translateX: [0, 200],
                opacity: [1,0],
                easing: "easeOutCubic",
                duration: 600,
                begin: function(){
                  $('#contrast-load-more-container').find('.project-item--parent').each(function(){
                    $(this).css('opacity','0');
                  });
                },
                complete: function() {
                  $('.our-work-listing-grid .work-grid-listing').empty().html($('#contrast-load-more-container').find('.work-grid-listing').html());
                  anime.timeline()          
                    .add({
                      targets: '.our-work-listing-grid .work-grid-listing .project-item--parent',
                      translateY: [150, 0],
                      translateX: [10, 0],
                      opacity: [0,1],  
                      easing: "easeOutCubic",
                      duration: 800,
                      
                    });
                },
                delay: function(el, i) {
                  return 200 + 30 * i;
                }
              });
            window.history.pushState( false, false, url );
          });
        });

        // Home Archive
        $(document).on('click','.our-work-listing .gallery-filters li a',function(e){
          e.preventDefault();
          var url = $(this).attr('data-href');
          console.log(url);
          $('#contrast-load-more-container').load(url + ' .gallery-item-cnt .grid-items, .gallery-filters', function(){
            
            $('.our-work-listing .gallery-filters').empty().html($('#contrast-load-more-container').find('.gallery-filters').html());
            anime.timeline()
            .add({
              targets: '.gallery-item-cnt .grid__item-container',
              translateY: [0, 150],
              opacity: [1,0],
              easing: "easeOutCubic",
              duration: 600,
              begin: function(){
                $('#contrast-load-more-container').find('.grid__item-container').each(function(){
                  $(this).css('opacity','0');
                });
              },
              complete: function() {
                $('.gallery-item-cnt').empty().html($('#contrast-load-more-container').find('.grid-items').html());
                //Sage.common.proximityHover();
                anime.timeline()          
                  .add({
                    targets: '.gallery-item-cnt .grid__item-container',
                    translateY: [150, 0],
                    opacity: [0,1],  
                    easing: "easeOutCubic",
                    duration: 800,
                    
                  });
              },
              delay: function(el, i) {
                return 200 + 30 * i;
              }
            });
          });
        });
      },
      footerCollapse: function() {
        if( window.innerWidth <= 767 ) {
          $('footer.main-footer').find('.footer-widget.widget-sectors').addClass('widget-open').find('.mobile-toggle').slideDown(0);
          $('footer.main-footer').on('click','h3',function(e){
            e.preventDefault();
            var widget = $(this).closest('.footer-widget');
            
            $('footer.main-footer .footer-widget.widget-open').each(function(){
              if ( $(this)[0] !== widget[0] ) {
                $(this).removeClass('widget-open').find('.mobile-toggle').slideUp('slow');
              }
            });

            if ( widget.hasClass('widget-open') ) {
              widget.find('.mobile-toggle').slideUp('slow');
              widget.removeClass('widget-open');
            } else {
              widget.find('.mobile-toggle').slideDown('slow');
              widget.addClass('widget-open');
            }
            
            
          });
        } else {

        }
      },
      proximityHover: function() {
        function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return right[Symbol.hasInstance](left); } else { return left instanceof right; } }

        function _classCallCheck(instance, Constructor) { if (!_instanceof(instance, Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

        /**
         * nearby.js
         * http://www.codrops.com
         *
         * Licensed under the MIT license.
         * http://www.opensource.org/licenses/mit-license.php
         * 
         * Copyright 2018, Codrops
         * http://www.codrops.com
         */
        {
          /**
          * Distance between two points P1 (x1,y1) and P2 (x2,y2).
          */
          var distancePoints = function distancePoints(x1, y1, x2, y2) {
            return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
          }; // from http://www.quirksmode.org/js/events_properties.html#position


          var getMousePos = function getMousePos(e) {
            var posx = 0,
                posy = 0;
            if (!e) var e = window.event;

            if (e.pageX || e.pageY) {
              posx = e.pageX;
              posy = e.pageY;
            } else if (e.clientX || e.clientY) {
              posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
              posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
            }

            return {
              x: posx,
              y: posy
            };
          };

          var _Nearby =
          /*#__PURE__*/
          function () {
            function _Nearby(el, options) {
              _classCallCheck(this, _Nearby);

              this.DOM = {
                el: el
              };
              this.options = options;
              this.init();
            }

            _createClass(_Nearby, [{
              key: "init",
              value: function init() {
                var _this = this;

                this.mousemoveFn = function (ev) {
                  return requestAnimationFrame(function () {
                    var mousepos = getMousePos(ev);
                    var docScrolls = {
                      left: document.body.scrollLeft + document.documentElement.scrollLeft,
                      top: document.body.scrollTop + document.documentElement.scrollTop
                    };

                    var elRect = _this.DOM.el.getBoundingClientRect();

                    var elCoords = {
                      x1: elRect.left + docScrolls.left,
                      x2: elRect.width + elRect.left + docScrolls.left,
                      y1: elRect.top + docScrolls.top,
                      y2: elRect.height + elRect.top + docScrolls.top
                    };
                    var closestPoint = {
                      x: mousepos.x,
                      y: mousepos.y
                    };

                    if (mousepos.x < elCoords.x1) {
                      closestPoint.x = elCoords.x1;
                    } else if (mousepos.x > elCoords.x2) {
                      closestPoint.x = elCoords.x2;
                    }

                    if (mousepos.y < elCoords.y1) {
                      closestPoint.y = elCoords.y1;
                    } else if (mousepos.y > elCoords.y2) {
                      closestPoint.y = elCoords.y2;
                    }

                    if (_this.options.onProgress) {
                      _this.options.onProgress(distancePoints(mousepos.x, mousepos.y, closestPoint.x, closestPoint.y));
                    }
                  });
                };

                window.addEventListener('mousemove', this.mousemoveFn);
              }
            }]);

            return _Nearby;
          }();

          window.Nearby = _Nearby;
        }
        /**
         * Equation of a line.
         */

        var lineEq = function lineEq(y2, y1, x2, x1, currentVal) {
          // y = mx + b 
          var m = (y2 - y1) / (x2 - x1),
              b = y1 - m * x1;
          return m * currentVal + b;
        };

        var shuffleArray = function shuffleArray(arr) {
          return arr.sort(function () {
            return Math.random() - 0.5;
          });
        };

        var gridItems = Array.from(document.querySelectorAll('.grid__item')); // whatever we do, start at [distanceThreshold.max]px from the element and end at [distanceThreshold.min]px from the element.

        var distanceThreshold = {
          min: 0,
          max: 50
        };
        var opacityInterval = {
          from: 0,
          to: 1
        };

        var scaleInterval = {from: 1.2, to: 1};

        gridItems.forEach(function (item) {
          var img = item.querySelector('.grid__item-img');
          new Nearby(img, {
            onProgress: function onProgress(distance) {
              if (img.classList.contains('grid__item-img--opaque')) {
                


                // var o = lineEq(opacityInterval.from, opacityInterval.to, distanceThreshold.max, distanceThreshold.min, distance);
                // TweenMax.to(img, 0.5, {
                //   ease: Expo.easeOut,
                //   opacity: Math.max(Math.min(o,opacityInterval.to),0)
                // });

                const s = lineEq(scaleInterval.from, scaleInterval.to, distanceThreshold.max, distanceThreshold.min, distance);

                TweenMax.to(img, 1.5, {
                    ease: Power2.easeOut,
                    scale: Math.min(s,scaleInterval.from)
                });
                
                // anime.timeline().add({
                //   targets: img,
                //   opacity: [Math.max(Math.min(o,opacityInterval.to),0), 0 ],
                //   easing: "easeInOutQuad",
                //   duration: 800
                // });
              }
            }
          });
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
